import { render, staticRenderFns } from "./Egg.vue?vue&type=template&id=166e1a10&"
import script from "./Egg.vue?vue&type=script&lang=js&"
export * from "./Egg.vue?vue&type=script&lang=js&"
import style0 from "./Egg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports